import React, { useState } from "react";
import { convertStringToArray } from "../../../../Utils/utils";
import Viewer from "react-viewer";

const Expense = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: `${process.env.REACT_APP_IMAGE_URL}/${img.file_path}`,
        alt: img.title,
      }))
    );
    setActiveIndex(index);
    setVisible(true);
  };

  // convert string into images array
  const imagesArray = convertStringToArray(data?.field_events_image);

  // customize array for light box

  return (
    <>
      {/* <!--content section start here--> */}
      <div className="mt-4">
        {/* <h2 className="title2">Our Approach</h2> */}
        <h2 className="title3">{data?.title}</h2>
      </div>
      <div className="mt-4">
        {/* <div className="title-sec">
          <h4>Photo Gallery</h4>
        </div> */}
        <div className="row">
          {imagesArray?.map((photo, index) => (
            <div
              className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4"
              key={index}
            >
              <a
                onClick={() => {
                  openViewer(imagesArray, index);
                }}
              >
                <div
                  className="card-sec wow zoomIn"
                  style={{
                    visibility: "visible",
                    animationName: "zoomIn",
                  }}
                >
                  <div className="img-sec">
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_IMAGE_URL}/${photo.file_path}`}
                    />
                  </div>
                  {/* <div className="desc-sec">
                  <div className="title-sec">
                    <h4>
                      <a href="javascript:void(0)">{photo.title}</a>
                    </h4>
                  </div>
                </div> */}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
};

export default Expense;
